import { apolloClient } from '@/common/service/apolloClient'
import { keywordAutoSuggestionQuery } from '@/common/queries'


export const getAutoCompleteSuggestions = (
  keyword: string
) => {
  return apolloClient.query<string>({
    query: keywordAutoSuggestionQuery,
    variables: {
      keyword: keyword
    },
    fetchPolicy: 'cache-first'
  })
}
